<div *transloco="let t;" class="plan-wrapper">
    <div class="plan-card">
        <span class="plan-card-art" aria-hidden="true"></span>
        <div class="plan-card-info">
            <h2 class="plan-card-name">
                {{ plan().displayName || plan().subscriptionName }}
            </h2>
            <p class="plan-card-price">
                <span class="plan-card-amount">{{ planPricing().amount | currency:'USD' }}</span>
                <span class="plan-card-period">
                    /{{ t(planPricing().periodKey) }}
                </span>
            </p>
        </div>
    </div>

    <ul class="perks" [attr.aria-label]="t('modals.premium_promo.perks_aria')">
        @for (perk of planPerks(); track perk.text) {
        <li class="perks-item" [class.perks-item-disabled]="perk.disabled">
            <span class="perks-label">{{ perk.text }}</span>

            @if (perk.factor) {
            <span class="perks-factor">{{ perk.factor }}</span>
            } @else if (!perk.disabled) {
            <cwo-round-icon 
                [iconName]="IconNameType.check"
                [attr.aria-label]="t('modals.premium_promo.perk_included_aria')" 
                [customSize]="'17px'"
                [customIconSize]="'9px'" 
                [customPadding]="'1px'" 
                [customBackgroundColor]="'var(--primary)'"
                [customColor]="'var(--white)'" 
                />
            }
        </li>
        }
    </ul>
</div>